import React from 'react'

export const Features = () => {
  return (
    <div className="grid mb-[34px] gap-20 grid-cols-2 relative before:absolute before:top-0 before:left-1/2 before:h-full before:w-px mt-[30px] before:bg-[#101A3614] before:-translate-x-1/2">
      <div className="flex justify-end items-center text-center">
        <div>
          <img
            className="mx-auto mb-2"
            width={32}
            height={32}
            src="/quiz/icons/performance-icon.png"
            alt="vector"
          />
          <p className="text-[14px] font-medium text-[#101A36B2]">Performance</p>
          <p className="font-semibold">Fast</p>
        </div>
      </div>

      <div className="flex justify-start items-center text-center">
        <div>
          <img
            className="mx-auto mb-2"
            width={32}
            height={32}
            src="/quiz/icons/spam2.png"
            alt="vector"
          />
          <p className="text-[14px] font-medium text-[#101A36B2]">Spam alerts</p>
          <p className="font-semibold">Blocked</p>
        </div>
      </div>
    </div>
  )
}
